export const GAMES_DATA = [
  {
    id: 1,
    slug: "cantajuego-bros",
    title: "Cantajuego Bros",
    description: "A platform adventure starring the Cantajuego crew. Run, jump and dodge your way to the end of each level.",
    emoji: "🍄",
    color: "indigo",
    tags: ["Platformer", "Keyboard & Touch"],
    path: "/games/cantajuego-bros.html"
  },
  {
    id: 2,
    slug: "flappy-bird",
    title: "Flappy Clon",
    description: "A one-tap classic: keep the bird in the air and slip through the pipes for as long as you can.",
    emoji: "🐤",
    color: "sky",
    tags: ["Arcade", "One button"],
    path: "/games/flappy-bird.html"
  },
  {
    id: 3,
    slug: "mario-jaca",
    title: "Las Aventuras de Super Mario: La Visita de Jaca",
    description: "A homemade platform adventure in Spanish, with cutscenes, dialogue and six levels. Made by and for the family.",
    emoji: "🐴",
    color: "emerald",
    tags: ["Platformer", "Keyboard & Touch", "Español"],
    thumbnail: "/games/mario-jaca/assets/logos/titulo.png",
    path: "/games/mario-jaca/index.html"
  },
  {
    id: 4,
    slug: "mario-tubo",
    title: "Super Mario: Viajando por el Tubo",
    description: "Mario dives into a green pipe and lands in another world. A platform adventure in Spanish, with cutscenes, dialogue and six levels.",
    emoji: "🟢",
    color: "amber",
    tags: ["Platformer", "Keyboard & Touch", "Español"],
    thumbnail: "/games/mario-tubo/assets/logos/titulo.png",
    path: "/games/mario-tubo/index.html"
  },
  {
    id: 5,
    slug: "molentary",
    title: "El Profesor Layton presenta: Viaje en el Molentary Express",
    description: "Luke, Flora and Professor Layton board the Molentary Express. Platforms and puzzles in Spanish, with cutscenes, dialogue and five levels.",
    emoji: "🚂",
    color: "rose",
    tags: ["Platformer", "Puzzles", "Keyboard & Touch", "Español"],
    thumbnail: "/games/molentary/assets/logos/titulo.png",
    path: "/games/molentary/index.html"
  },
  {
    id: 6,
    slug: "caja-pandora",
    title: "El Profesor Layton y la Caja de Pandora",
    description: "A remastered fan take on the Elysian Box. Platforms and puzzles in Spanish, with cutscenes, dialogue and six levels.",
    emoji: "🎁",
    color: "violet",
    tags: ["Platformer", "Puzzles", "Keyboard & Touch", "Español"],
    thumbnail: "/games/caja-pandora/assets/logos/titulo.png",
    path: "/games/caja-pandora/index.html"
  }
];
